export default __webpack_public_path__ + "static/media/logo_new.8c9cc356.png";